<template>
  <div>2323</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
